import { useNavigate } from "react-router-dom";

export const TestCoverage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ position: "relative" }}>
      <iframe className="coverage" src="/coverage/index.html"></iframe>
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 80,
        }}
        onClick={() => navigate("/")}
      >
        Zurück
      </button>
    </div>
  );
};
